import React from 'react';
import { companyInfo } from './mock';
import { CheckCircle2, Users, Beaker, Globe } from 'lucide-react';

const About = () => {
  return (
    <div className="w-full">
      {/* Header */}
      <section className="bg-gradient-to-br from-teal-50 via-white to-cyan-50 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">About Endemik Solutions</h1>
          <p className="text-xl text-gray-600">Committed to Excellence in Shawl Authentication</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Our Story */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              Endemik Solutions Private Limited was founded with a mission to combat counterfeit shawls and provide authentic laboratory testing services for premium textiles. With over 15 years of experience in textile analysis and quality assurance, we have become the trusted choice for authentication and adulteration testing across the region.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our team of certified experts uses state-of-the-art laboratory equipment to provide accurate, reliable, and timely results that help customers make informed purchasing decisions and ensure they receive authentic products.
            </p>
          </div>

          {/* Our Values */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Our Core Values</h2>
            <div className="grid md:grid-cols-2 gap-8">
              {[
                {
                  icon: CheckCircle2,
                  title: 'Accuracy',
                  description: 'We provide precise, certified results using advanced laboratory techniques and equipment.'
                },
                {
                  icon: Users,
                  title: 'Customer Focus',
                  description: 'Your satisfaction and trust are our highest priorities. We provide transparent communication at every step.'
                },
                {
                  icon: Beaker,
                  title: 'Innovation',
                  description: 'We continuously invest in the latest testing technologies and methodologies.'
                },
                {
                  icon: Globe,
                  title: 'Integrity',
                  description: 'We maintain the highest ethical standards in all our testing and reporting procedures.'
                }
              ].map((value, idx) => {
                const Icon = value.icon;
                return (
                  <div key={idx} className="p-6 bg-gray-50 rounded-lg hover:bg-teal-50 transition">
                    <Icon className="w-10 h-10 text-teal-600 mb-4" />
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{value.title}</h3>
                    <p className="text-gray-700">{value.description}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Our Expertise */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Expertise</h2>
            <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-8 rounded-lg border-l-4 border-teal-600">
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-teal-600 text-white rounded-full mr-3 mt-1">✓</span>
                  <span className="text-gray-700"><strong>Pashmina Authentication:</strong> Comprehensive verification of Pashmina origin and authenticity using multiple laboratory techniques</span>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-teal-600 text-white rounded-full mr-3 mt-1">✓</span>
                  <span className="text-gray-700"><strong>Fiber Composition Analysis:</strong> Detailed identification and quantification of fiber content</span>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-teal-600 text-white rounded-full mr-3 mt-1">✓</span>
                  <span className="text-gray-700"><strong>Adulteration Detection:</strong> Advanced testing to identify synthetic fibers and adulterants</span>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-teal-600 text-white rounded-full mr-3 mt-1">✓</span>
                  <span className="text-gray-700"><strong>Certified Reporting:</strong> Detailed, professional reports suitable for legal and commercial purposes</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white p-8 rounded-lg">
            <h2 className="text-3xl font-bold mb-6">Get in Touch</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <p className="text-teal-100 mb-2">📧 Email</p>
                <p className="text-lg font-semibold mb-6">{companyInfo.email}</p>
                
                <p className="text-teal-100 mb-2">📞 Phone</p>
                <p className="text-lg font-semibold mb-6">{companyInfo.phone}</p>
              </div>
              <div>
                <p className="text-teal-100 mb-2">📍 Address</p>
                <p className="text-lg font-semibold mb-6">{companyInfo.address}</p>
                
                <p className="text-teal-100 mb-2">🕐 Working Hours</p>
                <p className="text-lg font-semibold">{companyInfo.workingHours}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
